import type { DuckActionPayloadTuple } from '@aytm/app/insights/dashboard/duckness/poolDispatch'
import FiltersDuck from './FiltersDuck'
import { FILTERS_ACTIONS } from './FiltersDuck.actions'

export const makeResetFiltersAction = () => [FiltersDuck.duckName, FILTERS_ACTIONS.RESET] as DuckActionPayloadTuple

export const makeSetMinSampleSizeAction = (minSampleSize: number) =>
  [FiltersDuck.duckName, FILTERS_ACTIONS.SET_MIN_SAMPLE_SIZE, { minSampleSize }] as DuckActionPayloadTuple<{
    minSampleSize: number
  }>

export const makeApplyPanelFiltersAction = (filters: object) =>
  [
    FiltersDuck.duckName,
    FILTERS_ACTIONS.APPLY_CURRENT,
    {
      panelCurrentFilters: filters
    }
  ] as DuckActionPayloadTuple<{ panelCurrentFilters: object }>

export const makeClearAllFiltersAction = () =>
  [FiltersDuck.duckName, FILTERS_ACTIONS.CLEAR_ALL_PANEL] as DuckActionPayloadTuple

export const makeApplyPortalFiltersAction = (filters: object) =>
  [
    FiltersDuck.duckName,
    FILTERS_ACTIONS.APPLY_CURRENT,
    {
      portalCurrentFilters: filters
    }
  ] as DuckActionPayloadTuple<{ portalCurrentFilters: object }>

export const makeClearAllPortalFiltersAction = () =>
  [FiltersDuck.duckName, FILTERS_ACTIONS.CLEAR_ALL_PORTAL] as DuckActionPayloadTuple

export const makeCancelPanelFiltersAction = () =>
  [FiltersDuck.duckName, FILTERS_ACTIONS.CANCEL_CURRENT, { type: 'panel' }] as DuckActionPayloadTuple<{ type: string }>

export const makeCancelPortalFiltersAction = () =>
  [FiltersDuck.duckName, FILTERS_ACTIONS.CANCEL_CURRENT, { type: 'portal' }] as DuckActionPayloadTuple<{ type: string }>

export const makeUpdatePanelFiltersAction = (filters: object) =>
  [
    FiltersDuck.duckName,
    FILTERS_ACTIONS.UPDATE_CURRENT,
    {
      panelCurrentFilters: filters
    }
  ] as DuckActionPayloadTuple<{ panelCurrentFilters: object }>

export const makeUpdatePortalFiltersAction = (filters: object) =>
  [
    FiltersDuck.duckName,
    FILTERS_ACTIONS.UPDATE_CURRENT,
    {
      portalCurrentFilters: filters
    }
  ] as DuckActionPayloadTuple<{ portalCurrentFilters: object }>

export const makeToggleFilteredRowAveragesFilterAction = () =>
  [FiltersDuck.duckName, FILTERS_ACTIONS.TOGGLE_FILTERED_ROW_AVERAGES] as DuckActionPayloadTuple
